// extracted by mini-css-extract-plugin
module.exports = {"top":"CookiesPolicy_top__2whFM","content":"CookiesPolicy_content__XN0Wc"};